export default __webpack_public_path__ + "static/media/240.ecbbd0ff.gif";